/* Load from layout/theme.liquid with defer. No conversion key belongs in the theme. */
(() => {
  const STORAGE_KEY = 'sensereo_openai_ads_oppref';
  const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;
  const incoming = new URLSearchParams(location.search).get('oppref');
  const route = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let lastPayload = '';
  const isSyntheticTest = value => /^codex_test_/.test(value);

  function storedOppref() {
    try {
      const item = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (item && typeof item.value === 'string' && isSyntheticTest(item.value)) {
        localStorage.removeItem(STORAGE_KEY);
        return '';
      }
      if (item && typeof item.value === 'string' && item.value.length <= 1024 &&
          Number.isFinite(item.savedAt) && Date.now() - item.savedAt >= 0 &&
          Date.now() - item.savedAt < MAX_AGE_MS) {
        return item.value;
      }
    } catch (_) { /* Treat unreadable storage as empty. */ }
    return '';
  }

  async function updateCart(allowed) {
    let oppref = '';
    if (allowed) {
      if (incoming && isSyntheticTest(incoming)) {
        try { localStorage.removeItem(STORAGE_KEY); } catch (_) {}
      } else {
        oppref = incoming && incoming.length <= 1024 ? incoming : storedOppref();
        if (incoming && incoming.length <= 1024) {
          try { localStorage.setItem(STORAGE_KEY, JSON.stringify({value: incoming, savedAt: Date.now()})); } catch (_) {}
        }
      }
    } else {
      try { localStorage.removeItem(STORAGE_KEY); } catch (_) {}
    }

    const attributes = {
      __openai_ads_consent: allowed ? '1' : '',
      __openai_ads_oppref: allowed ? oppref : '',
    };
    const payload = JSON.stringify({attributes});
    if (payload === lastPayload) return;
    const response = await fetch(route + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'Content-Type': 'application/json'},
      body: payload,
    });
    if (!response.ok) throw new Error('Could not save OpenAI Ads cart attribution');
    lastPayload = payload;
  }

  if (!window.Shopify || !window.Shopify.loadFeatures) return;
  window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], (error) => {
    if (error || !window.Shopify.customerPrivacy) return;
    const sync = () => updateCart(window.Shopify.customerPrivacy.marketingAllowed()).catch(() => {});
    sync();
    document.addEventListener('visitorConsentCollected', sync);
  });
})();
